import React from "react";
import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";
import { ReactComponent as Icon } from "../svg/PepsiNavbar.svg";

export default function PepsiIcon(props: SvgIconProps) {
  return <SvgIcon {...props} component={Icon} inheritViewBox fontSize="inherit" />;
}
